import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { faqs } from '../data/mock';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <span className="text-secondary font-semibold text-sm uppercase tracking-wide">FAQ</span>
            <h2 className="text-3xl md:text-4xl font-bold text-primary mt-2 mb-4">
              Frequently Asked Questions
            </h2>
            <p className="text-gray-600 max-w-3xl mx-auto text-lg">
              Get answers to common questions about trademark registration. Can't find what you're looking for? Contact our expert team.
            </p>
          </div>

          {/* FAQ Accordion */}
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-white border-2 border-accent rounded-lg overflow-hidden hover:border-secondary transition-all shadow-sm"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-6 py-5 flex justify-between items-center text-left hover:bg-accent/30 transition-all"
                >
                  <span className="font-semibold text-primary text-base md:text-lg pr-4">
                    {faq.question}
                  </span>
                  <div className="flex-shrink-0">
                    {openIndex === index ? (
                      <ChevronUp className="text-secondary" size={24} />
                    ) : (
                      <ChevronDown className="text-secondary" size={24} />
                    )}
                  </div>
                </button>
                
                <div
                  className={`overflow-hidden transition-all duration-500 ease-in-out ${
                    openIndex === index ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-6 pb-6 pt-2">
                    <p className="text-gray-700 leading-relaxed text-sm md:text-base">{faq.answer}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Additional Help */}
          <div className="mt-12 text-center bg-accent/30 rounded-lg p-8">
            <h3 className="text-xl font-bold text-primary mb-3">Still Have Questions?</h3>
            <p className="text-gray-600 mb-6">
              Our trademark specialists are here to help. Contact us for personalized answers to your specific situation.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:+11231234567"
                className="bg-secondary text-white px-6 py-3 rounded-md hover:bg-secondary/90 transition-all font-semibold"
              >
                Call Us: +1 (123) 123-4567
              </a>
              <a
                href="mailto:info@registerbusinessnametrademark.com"
                className="bg-primary text-white px-6 py-3 rounded-md hover:bg-primary/90 transition-all font-semibold"
              >
                Email Our Team
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
